import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import '@/assets/css/global-m.css' //引入移动端全局样式配置
import '@/assets/css/richText.css'
import Vant from 'vant'
import 'vant/lib/index.css'

import App from './App'
import store from './store'
import router from './router'
import VueI18n from 'vue-i18n'
import i18n from '@/locale/index'
import getTranslation from '@/locale/getTranslation'
import './filters'
import '@/assets/css/qe.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import { getLang } from './utils'

//自定义js事件
import base from '@/utils/base'
Vue.prototype.$base = base

//创建bus  供平行组件通信
let bus = new Vue()
Vue.prototype.bus = bus

/**
 *vant注册
 */
Vue.use(Vant)

const lang = getLang()

Vue.use(ElementUI, lang === 'en-US' ? { locale } : {})
//Lazyload
import { Lazyload } from 'vant'
Vue.use(Lazyload)

Vue.use(VueI18n)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})

/*全局路由监听*/
router.beforeEach((to, from, next) => {
  //路由发生变化修改页面title
  if (to.meta.title) {
    document.title = getTranslation(to.meta.title)
  }
  //登录路由监听
  if (to.matched.some(m => m.meta.auth)) {
    // 对路由进行验证
    var token = localStorage.token
    if (!token) {
      // 未登录则跳转到登陆界面，query:{ redirect: to.fullPath}把当前路由信息传递过去方便登录后跳转回来；
      next({
        path: '/login',
        query: {
          // redirect: to.fullPath
        }
      })
      document.title = getTranslation('登录')
    }
  }
  next()
})
